var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardicon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "white",
    stroke: "#004276"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8842 24.153C16.5785 24.153 16.3747 24.0511 16.1708 23.8473L10.056 17.7324C9.75022 17.4266 9.64831 17.019 9.85214 16.6113C9.95405 16.2037 10.3617 15.9998 10.7694 15.9998H13.8268C14.6421 15.9998 15.4574 15.6941 15.967 15.0826C16.5785 14.573 16.8842 13.7577 16.8842 12.9424C16.8842 12.1271 16.5785 11.3118 15.967 10.8022C15.4574 10.1907 14.6421 9.88497 13.8268 9.88497H10.7694C10.1579 9.88497 9.75022 9.47731 9.75022 8.86582C9.75022 8.25434 10.1579 7.84668 10.7694 7.84668H21.98C22.5915 7.84668 22.9991 8.25434 22.9991 8.86582C22.9991 9.47731 22.5915 9.88497 21.98 9.88497H17.9034C18.5149 10.8022 18.9225 11.8213 18.9225 12.9424C18.9225 14.2673 18.413 15.5922 17.3938 16.5094C16.4766 17.5286 15.1517 18.0381 13.8268 18.0381H13.2153L17.5976 22.4205C18.0053 22.8281 18.0053 23.4396 17.5976 23.8473C17.3938 24.0511 17.19 24.153 16.8842 24.153Z",
    fill: "#004276"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9797 13.9616H10.7691C10.1577 13.9616 9.75 13.554 9.75 12.9425C9.75 12.331 10.1577 11.9233 10.7691 11.9233H21.9797C22.5912 11.9233 22.9989 12.331 22.9989 12.9425C22.9989 13.554 22.5912 13.9616 21.9797 13.9616Z",
    fill: "#004276"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardicon4);
export default __webpack_public_path__ + "static/media/dashboardicon4.e8d7270b5d3d13e5a19a4d4b17d682ec.svg";
export { ForwardRef as ReactComponent };